export const locale = {
    lang: 'pt',
    data: {
        ORDER_DETAIL: {
            TITLE: 'Detalhes do pedido',
            DATE_FORMAT_WITH_HOUR: "dd/MM/yyyy 'às' HH:mm",
            DATETIME_FORMAT: 'dd/MM/yyyy HH:mm',
            DATE_FORMAT: 'dd/MM/yyyy',
            DATE_FORMAT_DAY_MONTH: 'dd/MM',
            DATETIME_FORMAT_DAY_MONTH: 'dd/MM HH:mm',
            DATE_WITH_TIME: '{{ date }} às {{ time }}',
            MENU: {
                NAME: 'Pedido {{ number }}',
                DETAIL: 'Detalhe do pedido',
                BACK: 'Voltar',
                APPROVAL_DESCRIPTION: 'Seu orçamento está aguardando aprovação.',
                APPROVE: 'Aprovar',
                LABORATORY: 'Laboratório',
                RECEIVER: 'Recebido por',
                ADDRESS: 'Endereço',
                APP: 'App',
                STATUS: 'Status',
                CUSTOMER: 'Cliente',
                CUSTOMERS: 'Clientes',
                CUSTOMER_USER: 'Dentista',
                CREATED_AT: 'Data de entrada',
                APPROVED_AT: 'Data de aprovação',
                EXPECTED_DATE: 'Data prevista',
                END_DATE: 'Data de finalização',
                CREATED_BY: 'Criador por',
                PATIENT: 'Paciente',
                PATIENT_GENDER: 'Gênero',
                PATIENT_BIRTHDATE: 'Data de nascimento',
                RATING: 'Avaliação',
                CREATE_RATING: 'Fazer avaliação',
                DELIVERY_ROUTE: 'Rota de entrega',
            },
            DELIVERY_ROUTE: {
                FINISHED_DATE: 'Data de entrega',
                EXPECTED_DATE: 'Data prevista',
                TRACKING_NUMBER: 'Código de rastreio',
                PERIOD: 'Período',
                STATUS: 'Status',
            },
            REMAKE: {
                ORDER: 'Pedido',
                REMAKE: 'Repetição',
                ADJUSTMENT: 'Ajuste',
                ORIGINAL_ORDER: 'Original',
                SEQUENCE: 'Sequência',
            },
            REMAKE_TYPE: {
                REMAKE: 'Repetição',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Ajuste',
                ADJUSTMENT_INITIAL: 'A',
            },
            TABS: {
                INFORMATION: 'Informações',
                FILES: 'Arquivos',
                CHAT: 'Chat',
            },
            FORM: {
                FIELDS: {
                    SEARCH: 'Buscar por nome ou número',
                },
            },
            TOOLTIP: {
                IS_DELIVERY_CONFIRMED: 'Entrega confirmada',
            },
            TOASTR: {
                ORDER_APPROVE: {
                    SUCCESS: {
                        MESSAGE: 'Pedido aprovado com sucesso',
                    },
                },
            },
            MODAL: {
                ORDER_RATING: {
                    TITLE: 'Avaliação do pedido',
                },
                BUTTONS: {
                    CREATE: 'Criar',
                    SAVE: 'Salvar',
                    PRINT: 'Imprimir',
                    CANCEL: 'Cancelar',
                },
            },
        },
    },
};
